import styled from 'styled-components';

const PaginationStyled = styled.ul`
  position: absolute;
  right: 0;
  bottom: 8px;
  left: 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .Pagination {
    &__dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #ffffff;
      cursor: pointer;
      list-style: none;
      opacity: 0.8;
      transition: opacity 0.2s;
      margin-bottom: 8px;

      &:not(:first-child) {
        margin-left: 12px;
      }

      &:hover,
      &:focus {
        opacity: 1;
      }

      &--active {
        opacity: 1;
      }
    }
  }
`;

export { PaginationStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
